import React, { useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioQualificacaoFornecedoresPrint.css";

const ID_QUADRO_IMPRESSAO = "quadro-impressao-qualificacao-fornecedores";

const ESTILOS_IMPRESSAO = `
  @page { size: A4 landscape; margin: 8mm; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #071b31; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-qualificacao-fornecedores { width: 100%; }
  .cabecalho-pdf-qualificacao-fornecedores, .tabela-pdf-qualificacao-fornecedores { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-pdf-qualificacao-fornecedores td { border: 1px solid #153d64; padding: 6px; text-align: center; }
  .cabecalho-pdf-qualificacao-fornecedores td:first-child { width: 28mm; }
  .cabecalho-pdf-qualificacao-fornecedores td:last-child { width: 43mm; }
  .cabecalho-pdf-qualificacao-fornecedores img { max-width: 26mm; max-height: 15mm; }
  .cabecalho-pdf-qualificacao-fornecedores strong, .cabecalho-pdf-qualificacao-fornecedores span { display: block; }
  .cabecalho-pdf-qualificacao-fornecedores td:nth-child(2) strong { color: #0b4b78; font-size: 15px; }
  .cabecalho-pdf-qualificacao-fornecedores span { margin-top: 3px; font-size: 11px; }
  .cabecalho-pdf-qualificacao-fornecedores .identificacao-pdf-qualificacao-fornecedores { padding: 0; }
  .cabecalho-pdf-qualificacao-fornecedores .identificacao-pdf-qualificacao-fornecedores div { padding: 5px 3px; font-size: 11px; }
  .cabecalho-pdf-qualificacao-fornecedores .identificacao-pdf-qualificacao-fornecedores div + div { border-top: 1px solid #153d64; }
  .resumo-pdf-qualificacao-fornecedores { margin: 3mm 0; padding: 2.5mm; border: 1px solid #8da1b5; font-size: 9px; line-height: 1.35; }
  .resumo-pdf-qualificacao-fornecedores strong { color: #0b4774; }
  .tabela-pdf-qualificacao-fornecedores { font-size: 7px; }
  .tabela-pdf-qualificacao-fornecedores th, .tabela-pdf-qualificacao-fornecedores td { border: 1px solid #777; padding: 3px 2px; text-align: center; vertical-align: middle; overflow-wrap: anywhere; }
  .tabela-pdf-qualificacao-fornecedores th { background: #0b4774; color: #fff; font-size: 7px; }
  .tabela-pdf-qualificacao-fornecedores th:first-child { background: #1e1156; }
  .tabela-pdf-qualificacao-fornecedores td:first-child { text-align: left; font-weight: 700; }
  .tabela-pdf-qualificacao-fornecedores thead { display: table-header-group; }
  .tabela-pdf-qualificacao-fornecedores tr { break-inside: avoid; page-break-inside: avoid; }
  .tabela-pdf-qualificacao-fornecedores tbody tr:nth-child(even) { background: #f4f7f9; }
`;

const valor = (conteudo) => String(conteudo ?? "").trim() || "-";

function formatarNota(conteudo) {
  const numero = Number(conteudo || 0);
  return Number.isInteger(numero) ? String(numero) : numero.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
}

function situacao(nota) {
  if (nota >= 117) return "QUALIFICADO";
  if (nota >= 91) return "ACOMPANHADO";
  return "REJEITADO";
}

function imprimirRelatorio(elemento, nomeArquivo) {
  if (!elemento) return;

  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();
  const quadroImpressao = document.createElement("iframe");
  quadroImpressao.id = ID_QUADRO_IMPRESSAO;
  quadroImpressao.title = "Impressão da Qualificação de Fornecedores";
  Object.assign(quadroImpressao.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadroImpressao);

  const janelaImpressao = quadroImpressao.contentWindow;
  const documentoImpressao = quadroImpressao.contentDocument;
  documentoImpressao.open();
  documentoImpressao.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_IMPRESSAO}</style></head><body></body></html>`);
  documentoImpressao.close();
  documentoImpressao.body.appendChild(elemento.cloneNode(true));

  const imagens = Array.from(documentoImpressao.images);
  Promise.all(imagens.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(() => {
    janelaImpressao.onafterprint = () => quadroImpressao.remove();
    janelaImpressao.focus();
    janelaImpressao.print();
  });
}

export default function RelatorioQualificacaoFornecedoresPrint({ registros, criterios, versao, aprovadoEm, objetivo, criteriosResultado, onVoltar }) {
  const paginaRef = useRef(null);
  const nomeArquivo = `RQ-7.1-CADASTRO-E-QUALIFICACAO-DE-FORNECEDORES-REV-${versao}`;
  useNomeArquivoPdf(nomeArquivo);

  return (
    <div className="relatorio-qualificacao-fornecedores-print">
      <div className="acoes-relatorio-qualificacao-fornecedores">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-qualificacao-fornecedores" onClick={() => imprimirRelatorio(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>

      <main ref={paginaRef} className="pagina-pdf-qualificacao-fornecedores">
        <table className="cabecalho-pdf-qualificacao-fornecedores">
          <tbody>
            <tr>
              <td><LogoRelatorio alt="Logo da empresa" /></td>
              <td><strong>CADASTRO E QUALIFICAÇÃO DE FORNECEDORES</strong><span>Sistema de Gestão da Qualidade</span></td>
              <td className="identificacao-pdf-qualificacao-fornecedores"><div><strong>RQ 7.1</strong></div><div>Revisão {valor(versao)}</div><div>{valor(aprovadoEm)}</div></td>
            </tr>
          </tbody>
        </table>

        <div className="resumo-pdf-qualificacao-fornecedores">
          <div><strong>Objetivo:</strong> {valor(objetivo)}</div>
          <div><strong>Critérios do resultado:</strong> {valor(criteriosResultado)}</div>
        </div>

        <table className="tabela-pdf-qualificacao-fornecedores">
          <colgroup>
            <col style={{ width: "18%" }} />
            {criterios.map(({ campo }) => <col key={campo} style={{ width: "8%" }} />)}
            <col style={{ width: "7%" }} />
            <col style={{ width: "11%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Fornecedor</th>
              {criterios.map(({ campo, titulo, limite }) => <th key={campo}>{titulo}<br />Máx. {limite}</th>)}
              <th>Nota</th>
              <th>Situação</th>
            </tr>
          </thead>
          <tbody>
            {registros.map((registro) => {
              const nota = Number(registro.nota || 0);
              return (
                <tr key={registro.id}>
                  <td>{valor(registro.fornecedor)}</td>
                  {criterios.map(({ campo }) => <td key={campo}>{formatarNota(registro[campo])}</td>)}
                  <td><strong>{formatarNota(nota)}</strong></td>
                  <td><strong>{situacao(nota)}</strong></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    </div>
  );
}
